/* eslint-disable no-unused-expressions */
import ResizeTracker from 'utils/ResizeTracker';
import scrollTo from 'ui/scrollTo';


class ScenariosVisual {
    constructor(element, options = {}) {
        this._element = element;
        this._options = Object.assign({}, ScenariosVisual.options, options);

        this._elements = {
            scenarioTriggers: [...document.querySelectorAll(
                this._options.scenarioTriggersSelector
            )],
            scenarioGrayArrows: [...document.querySelectorAll(
                this._options.scenarioGrayArrowsSelector
            )],
            scenarioGrayArrowsContainer: document.querySelector(
                this._options.scenarioGrayArrowsContainerSelector
            ),
            header: document.querySelector('.header')
        };

        this._onTriggerClick = this._onTriggerClick.bind(this);
        this._onTriggerHover = this._onTriggerHover.bind(this);
        this._onTriggerOut = this._onTriggerOut.bind(this);
        this._handleResize = this._handleResize.bind(this);

        this._bindEvents();
        this._setCurrentScenario(this._options.currentScenario);

        this.MOVE_UP = 1;
        this.MOVE_DOWN = -1;
        this.HEADER_HEIGHT = 0;
        this.MOBILE_SIZE = 768;
        this.IS_MOBILE = false;
        this.TIMEOUT = 600;

        const resizeTracker = new ResizeTracker();

        resizeTracker.init(
            { element: document.documentElement },
            this._handleResize
        );

        this._handleResize();
    }

    static get options() {
        return {
            scenarioTriggersSelector: '[data-scenario]',
            scenarioGrayArrowsSelector:
                '.scenarios-visual__visual g path[data-scenario]',
            scenarioGrayArrowsContainerSelector: '.scenarios-visual__visual g',
            currentScenario: null
        };
    }

    _setCurrentScenario(scenario) {
        this._element.setAttribute('data-current-scenario', scenario);
        this._elements.scenarioTriggers.forEach(trigger => {
            const active = trigger.getAttribute('data-scenario') === scenario;
            const link = trigger.querySelector('a');

            if (link) {
                const panel = link.nextElementSibling;
                link.setAttribute('aria-expanded', String(active));
                panel.setAttribute('aria-hidden', String(!active));
            }

            trigger.setAttribute('data-active', String(active));
        });

        this._sortScenarioArrows();
    }

    _onTriggerClick(event) {
        event.preventDefault();
        const scenario = event.currentTarget.getAttribute('data-scenario');
        const isLink = event.currentTarget.classList.contains('scenarios-visual__description-item');
        this.IS_MOBILE && this._triggerScroll(event.currentTarget, isLink);
        this._setCurrentScenario(scenario);
    }

    _triggerScroll(target, isLink) {
        const scrollTarget = isLink ? target : target.closest('.scenarios-visual__wrapper');
        const timeout = setTimeout(() => {
            const currentScroll = window.scrollY || window.scrollTop || window.pageYOffset;
            const targetBoundingBox = scrollTarget.getBoundingClientRect();
            const offset = targetBoundingBox.top + currentScroll - this.HEADER_HEIGHT;
            scrollTo(null, offset);
            clearTimeout(timeout);
        }, this.TIMEOUT);

    }


    _onTriggerHover(event) {
        const scenario = event.currentTarget.getAttribute('data-scenario');

        this._elements.scenarioTriggers.forEach(trigger => {
            const active = trigger.getAttribute('data-scenario') === scenario;
            trigger.setAttribute('data-hover', String(active));
        });
    }

    _onTriggerOut() {
        this._elements.scenarioTriggers.forEach(trigger => {
            trigger.removeAttribute('data-hover');
        });
    }

    _handleResize() {
        // eslint-disable-next-line no-magic-numbers
        const em = parseFloat(getComputedStyle(this._elements.header).fontSize) * 4;
        this.HEADER_HEIGHT = this._elements.header.offsetHeight + em;
        this.IS_MOBILE = document.body.clientWidth < this.MOBILE_SIZE;
    }

    _bindEvents(bool = true) {
        const method = bool ? 'addEventListener' : 'removeEventListener';
        this._elements.scenarioTriggers.forEach(trigger => {
            trigger[method]('click', this._onTriggerClick, {
                useCapture: true
            });

            trigger[method]('mouseenter', this._onTriggerHover, {
                useCapture: true
            });

            trigger[method]('mouseleave', this._onTriggerOut, {
                useCapture: true
            });
        });
    }

    _sortScenarioArrows() {
        const items = [...this._elements.scenarioGrayArrows];

        items
            .sort(prev => this._isArrowActive(prev))
            .forEach(item => this._elements.scenarioGrayArrowsContainer.appendChild(item));
    }

    _isArrowActive(arrow) {
        return arrow.dataset && arrow.dataset.active === 'true' ? this.MOVE_UP : this.MOVE_DOWN;
    }

    unload() {
        this._bindEvents(false);
    }
}

export default ScenariosVisual;
/* eslint-enable */

